import React from 'react'
import styled from 'styled-components'
import SkeletonLeaderItemArticle from '../../components/ItemArticle/views_leader/LeaderItemArticle/skeleton'
import SkeletonBigLeaderItemArticle from '../../components/ItemArticle/views_leader/BigLeaderItemArticle/skeleton'
import {
  BigLeader0WidgetLeader,
  containerQuery0WidgetLeader,
  SecondLeader0WidgetLeader,
  StyledContainerAd0WidgetLeader,
  StyledItemArticle0WidgetLeader,
  ThirdLeader0WidgetLeader,
  Wrapper0WidgetLeader,
  WrapperArticles0WidgetLeader,
} from '.'
import { ContainerQuery } from 'react-container-query'
import SkeletonHeadlinePaper from '../../../Paper/widgets/WidgetHeadlinePaper/skeleton'

const StyledWrapperArticles0WidgetLeader = styled(WrapperArticles0WidgetLeader)`
  @media((max-width: ${props => props.theme.tablet.breakPoint + 'px'}) and (min-width: ${props =>
  props.theme.mobile.breakPoint + 'px'})){
    ${StyledContainerAd0WidgetLeader} {
      flex-basis: calc((100% - 30px) / 6 * 3 + 12px);
      flex-wrap: wrap;
      align-items: center;
      align-content: space-evenly;
      margin: 0;
      padding: 0;
    }
    ${BigLeader0WidgetLeader} {
      display: flex;
      flex-basis: 100%;
      padding-bottom: 6px;
    }
    ${SecondLeader0WidgetLeader}, ${ThirdLeader0WidgetLeader} {
      display: flex;
      flex-basis: 100%;
      flex-direction: row;
      justify-content: space-between;

      ${StyledItemArticle0WidgetLeader} {
        margin-bottom: 0;
        overflow: unset;
        flex-basis: calc((100% - 30px) / 6 * 3 + 12px);
      }
      ${StyledContainerAd0WidgetLeader} {
        justify-content: space-evenly;
        align-content: center;
        flex-direction: column;
      }
    }
  }
  @media(max-width: ${props => props.theme.mobile.breakPoint + 'px'}){
    padding-left: 0;
    padding-right: 0;
    
    ${BigLeader0WidgetLeader} {
      padding-bottom: 0;
    }
    ${BigLeader0WidgetLeader}, ${SecondLeader0WidgetLeader}, ${ThirdLeader0WidgetLeader} {
      ${StyledItemArticle0WidgetLeader} {
        margin: 10px 10px 0 10px;
        width: auto;
      }
    }
    ${StyledContainerAd0WidgetLeader} {
      flex-basis: 100%;
      margin-top: ${props => props.theme.mobile.sizes.gapVertical};

      > div {
        margin-bottom: ${props => props.theme.mobile.sizes.gapVertical};
      }
      > div:last-child {
        margin-bottom: 0;
      }
    }
  }
`
const SkeletonWidgetLeader = ({ adIds, ...props }) => {
  return (
    <ContainerQuery query={containerQuery0WidgetLeader} {...props}>
      {themeMode => (
        <Wrapper0WidgetLeader {...props}>
          <StyledWrapperArticles0WidgetLeader themeMode={themeMode}>
            <BigLeader0WidgetLeader>
              <StyledItemArticle0WidgetLeader as={SkeletonBigLeaderItemArticle} />
            </BigLeader0WidgetLeader>
            <SecondLeader0WidgetLeader>
              <StyledItemArticle0WidgetLeader second_leader_item as={SkeletonLeaderItemArticle} />
              <StyledItemArticle0WidgetLeader second_leader_item as={SkeletonLeaderItemArticle} />
            </SecondLeader0WidgetLeader>
            <ThirdLeader0WidgetLeader>
              <StyledItemArticle0WidgetLeader as={SkeletonLeaderItemArticle} />
              <StyledItemArticle0WidgetLeader as={SkeletonLeaderItemArticle} />
              <StyledItemArticle0WidgetLeader as={SkeletonLeaderItemArticle} />
              {(themeMode.mobile || themeMode.tablet) && <StyledContainerAd0WidgetLeader adIds={adIds} />}
            </ThirdLeader0WidgetLeader>
            {!themeMode.mobile && !themeMode.tablet && <StyledContainerAd0WidgetLeader noGapEdge adIds={adIds} />}
          </StyledWrapperArticles0WidgetLeader>
          <SkeletonHeadlinePaper />
        </Wrapper0WidgetLeader>
      )}
    </ContainerQuery>
  )
}

export default SkeletonWidgetLeader
